import { makeStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectedHotelSelector } from '../../property/propertySlice';
import MessageList from './message-list/Message-List';
import {
  WELCOME_MESSAGE_CREATE,
  WELCOME_MESSAGE_VIEW,
} from '../../../constants/WelcomeMessageConst';
import { Drawer } from '@material-ui/core';
import MessageCreateView from './message-create-view/Message-Create-View';

const useStyles = makeStyles((theme) => ({
  activeButton: {
    color: '#29E67C',
    borderRadius: '26px',
    border: '2px solid #74E287',
    opacity: 1,
    fontWeight: 600,
    fontSize: '1.2em',
  },
  button: {
    borderRadius: '26px',
    fontWeight: 600,
    fontSize: '1.2em',
  },
  input: {
    display: 'none',
  },
}));

const Messages = (props) => {
  const { permissions } = props;
  const [activeTab, setActiveTab] = useState('MESSAGES');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [drawerWidth, setDrawerWidth] = useState('1000px');
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerType, setDrawerType] = useState('');
  const [viewOpen, setViewOpen] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const classes = useStyles();
  const selectedHotel = useSelector(selectedHotelSelector);
  const [drawerState, setDrawerState] = useState({
    type: '',
    status: false,
    obj: null,
  });
  const [refreshToggle, setRefreshToggle] = useState(false);
  const [editOption, setEditOption] = useState(false);

  const drawerStyles = makeStyles((theme) => ({
    drawer: {
      '& .MuiDrawer-paper': {
        transition: 'width 0.3s ease-in-out',
      },
    },
  }));
  const drawerClasses = drawerStyles();

  const [viewState, setViewState] = useState({
    type: '',
    status: false,
    obj: null,
  });
  const handleDrawerToggle = (type, isOpen, message) => {
    setDrawerType(type);
    setDrawerOpen(isOpen);
    setSelectedMessage(message);
  };

  const onDrawerToggle = (type, status, obj = null, mode = null) => {
    if (!status) {
      setDrawerWidth('1000px');
    }
    setDrawerState({
      type: type,
      status: status,
      obj: obj,
      mode: mode,
    });
  };

  const onViewToggle = (type, status, obj = null) => {
    setViewState({
      type: type,
      status: status,
      obj: obj,
    });
  };

  useEffect(() => {
    const handleEditEvent = (e) => {
      onDrawerToggle('WELCOME_MESSAGE_CREATE', true, e.detail);
    };

    window.addEventListener('editWelcomeMessage', handleEditEvent);
    return () => window.removeEventListener('editWelcomeMessage', handleEditEvent);
  }, []);

  const handleViewToggle = (type, isOpen, message) => {
    setDrawerType(type);
    setViewOpen(isOpen);
    setSelectedMessage(message);
  };

  return (
    <>
      <Drawer
        anchor='right'
        open={drawerState.status}
        onClose={() => onDrawerToggle('', false)}
        className={`right-drawer ${drawerClasses.drawer}`}
        disableBackdropClick={true}
        disableEscapeKeyDown={true}
        PaperProps={{
          style: {
            width: drawerWidth,
            transition: 'width 0.3s ease-in-out',
            overflowX: 'hidden',
            minWidth: '1000px',
          },
        }}
      >
        <MessageCreateView
          message={drawerState.obj}
          onSave={(updatedFormData, shouldRefresh = false) => {
            if (shouldRefresh) {
              setRefreshToggle((prev) => !prev);
            }
          }}
          onClose={() => onDrawerToggle('', false)}
          onEdit={(msgToEdit) => {
            onDrawerToggle(WELCOME_MESSAGE_CREATE, true, msgToEdit);
          }}
          onTabChange={({ tabIndex, width }) => {
            setDrawerWidth(width);
          }}
          isCreate={drawerState.type === 'message_create' ? true : false}
        />
      </Drawer>
      <div className='container mt-4'>
        <div className='row d-flex'>
          <div className='col-md-6'>
            <span className='page-title mx-2'>Welcome Message</span>
          </div>
        </div>
        <div className='row mx-2 d-flex mt-4'>
          <div className='card shadow'>
            {activeTab === 'MESSAGES' && (
              <MessageList
                selectedHotel={selectedHotel}
                permissions={permissions}
                onDrawerToggle={onDrawerToggle}
                onViewToggle={handleViewToggle}
                onsetPage={(e) => setPage(e)}
                page={page}
                onsetRowsPerPage={(e) => setRowsPerPage(e)}
                rowsPerPage={rowsPerPage}
                refreshToggle={refreshToggle}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Messages;
